module.exports = __webpack_public_path__ + "static/media/place-6.20a4f151.jpg";